const statusMap = {
  1: 'NS',
  2: '1P',
  3: '1B',
  4: '2P',
  5: '2B',
  6: '3P',
  7: 'END',
  8: 'A. OT',
  9: 'OT',
  10: 'END OT',
  11: 'A. PT',
  12: 'PT',
  13: 'END PT',
};

const scorePeriodsMap = {
  1: '1P',
  2: '2P',
  3: '3P',
  4: 'OT',
  5: 'PT',
};

function mapIceHockeyPeriods(periods = []) {
  if (!periods?.length) return [];

  return periods.reduce((score, { id, value: n }) => {
    score.push({ label: scorePeriodsMap[id], scores: [n.home, n.away] });
    return score;
  }, []);
}

export function mapIceHockeyEvent(event) {
  return {
    displayEventStatus: true,
    eventStatus: statusMap[event.eventStatusId],
    eventStatusId: event.eventStatusId,
    periods: mapIceHockeyPeriods(event.events.find((event) => event.id === 3)?.periods),
    currentGameScore: event.events.find((event) => event.id === 1)?.value ?? null,
    eventTime: event.events.find((event) => event.id === 8)?.value?.value || 0,
  };
}
